




























































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import SettingInfo from '@/components/shared/SettingInfo.vue';
import NetworkVisualCue from '@/components/explorer/NetworkVisualCue.vue';

@Component({
  components: {
    SettingInfo,
    NetworkVisualCue,
  },
})
export default class SidebarMenu extends Vue {
  public reduce = true;
  public sidebar: any = [
    {
      name: 'Explorer',
      icon: 'search',
      to: { name: 'explorer' },
      tag: 'router-link',
    },
    {
      name: 'Accounts',
      icon: 'users',
      to: { name: 'accounts' },
      tag: 'router-link',
    },
    {
      name: 'Transfer',
      icon: 'paper-plane',
      to: { name: 'transfer' },
      tag: 'router-link',
    },
    {
      name: 'Democracy',
      icon: 'calendar-check',
      to: { name: 'democracy' },
      tag: 'router-link',
    },
    {
      name: 'Staking',
      icon: 'seedling',
      to: { name: 'staking' },
      tag: 'router-link'
    },
    {
      name: 'Treasury',
      icon: 'gem',
      to: { name: 'treasury' },
      tag: 'router-link',
    },
    {
      name: 'Chain State',
      icon: 'database',
      to: { name: 'chainstate' },
      tag: 'router-link'
    },
    {
      name: 'Extrinsics',
      icon: 'sync',
      to: { name: 'extrinsics' },
      tag: 'router-link',
    },
    {
      name: 'Settings',
      icon: 'cogs',
      to: { name: 'settings' },
      tag: 'router-link',
    },
    {
      name: 'Toolbox',
      icon: 'tools',
      to: { name: 'toolbox' },
      tag: 'router-link'
    },
    {
      name: 'Debug',
      icon: 'bug',
      to: { name: 'debug' },
    },
    {
      name: 'RPC',
      icon: 'exchange-alt',
      to: { name: 'rpc' },
      tag: 'router-link'
    }
  ];
  public externalLinks: any = [
    {
      name: 'Github',
      icon: 'code-branch',
      href: 'https://github.com/vue-polkadot/apps',
      target: '_blank'
    },
    {
      name: 'Wiki',
      icon: 'book',
      href: 'https://wiki.polkadot.network/',
      target: '_blank'
    },
    {
      name: '@KodaDot',
      icon: 'twitter',
      pack: 'fab',
      href: 'https://twitter.com/KodaDot',
      target: '_blank'
    },
  ];
  public currentRow: any = this.sidebar[0];
  public isSidebarClosed = true;
  public showVerbose = false;
  public isActive = true;
  get hasBasicMode() {
    return this.$store.getters.getSettings.uiMode === 'light';
  }

  @Emit('toggle')
  public toggleSidebar() {
    this.reduce = !this.reduce;
    return this.reduce;
  }

  get toggleIcon() {
    return this.reduce ? 'angle-double-right' : 'angle-double-left'
  }

  get mobileView() {
    return this.reduce ? 'reduce' : ''
  }

}
